/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileUnzip = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M4 2h9v2H6v16h12v-1h2v3H4V2z" fill="currentcolor" />
      <path
        d="M11.865 17v-.744l2.291-3.242h-2.21v-.885h3.544v.724l-2.305 3.263h2.392V17h-3.712zm4.415 0v-4.87h1.045V17h-1.046zm1.995 0v-4.87h1.742c.599 0 1.05.138 1.354.414.308.277.462.688.462 1.233 0 .54-.154.952-.462 1.233-.304.277-.755.415-1.354.415h-.703V17h-1.039zm1.528-4.02h-.49v1.595h.49c.357 0 .61-.06.757-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.148-.12-.4-.181-.757-.181zM20 5.414V10h-2V5.414l-1.293 1.293-1.414-1.414L19 1.586l3.707 3.707-1.414 1.414L20 5.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileUnzip as FileUnzip };
